export default __webpack_public_path__ + "static/media/b9.eb20f6cc.webp";